import BaseService from "core/api/BaseService";
import { API_ENDPOINTS } from "utils/constants";

class FollowService extends BaseService {
  constructor() {
    super(API_ENDPOINTS.FOLLOWS.BASE);
  }

  async followUser(followingId) {
    return this.create({ followingId });
  }

  async unfollowUser(followingId) {
    return this.delete(followingId);
  }

  async checkFollow(userId) {
    return this.get(API_ENDPOINTS.FOLLOWS.CHECK(userId));
  }

  async getMyFollowing() {
    return this.get(API_ENDPOINTS.FOLLOWS.MY_FOLLOWING);
  }

  async getMyFollowers() {
    return this.get(API_ENDPOINTS.FOLLOWS.MY_FOLLOWERS);
  }

  async getFollowCount(userId) {
    return this.get(API_ENDPOINTS.FOLLOWS.COUNT(userId));
  }
}

export default new FollowService();
